import styles from './neetmocktest.module.css'
import offlinemodeicon from '../../assets/offline_mode_icon.svg'
import syllbusicon from '../../assets/syllabus_icon.svg'
import importantIcon from '../../assets/neet_important_icon.svg'
const NeetTestCriteria = () => {

    return (
        <div>
            <div className={`container ${styles.bg_mweb}`}>
                {/*--------MOCK NEET Test Criteria*/}
                <div className={`${styles.mn_criteria}`}>
                    <div className={`${styles.test_detail_wrapper}`}>
                        <h2>Test details</h2>
                        <div className={`${styles.test_dt_three}`}>
                            {/* box1 */}
                            <div className={`${styles.test_dt_box}`}>
                                <div>
                                    <img
                                        src={offlinemodeicon}
                                        alt="offlinemodeicon" />
                                </div>
                                <div>
                                    <h6>Offline mode</h6>
                                    <p>Focused exam experience, the traditional way</p>
                                </div>
                            </div>
                            <div className={`${styles.br_rt}`}></div>
                            {/* box1 */}
                            {/* box2 */}
                            <div className={`${styles.test_dt_box}`}>
                                <div>
                                    <img
                                        src="https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/time-icon2.svg"
                                        alt="time-icon" />
                                </div>
                                <div>
                                    <h6>Date</h6>
                                    <p>26th April 2026</p>
                                </div>
                            </div>
                            <div className={`${styles.br_rt}`}></div>
                            {/* box2 */}
                            {/* box3 */}
                            <div className={`${styles.test_dt_box}`}>
                                <div>
                                    <img
                                        src="https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/watch-icon3.svg"
                                        alt="watch-icon" />
                                </div>
                                <div>
                                    <h6>Time</h6>
                                    <p>2:00 PM – 05:00 PM</p>
                                </div>
                                {/* box3 */}
                            </div>
                        </div>
                    </div>
                    {/*--------MOCK NEET Criteria*/}
                    {/* -------MOCK NEET test prepration */}
                    <div className={`${styles.testprep_wrapper}`}>
                        <div className={`${styles.test_pre_box}`}>
                            <div className={`${styles.heading_test}`}>
                                <h2>Test preparation</h2>
                            </div>
                            <div className={`${styles.detail_pre}`}>
                                <div className={`${styles.detail1}`}>
                                    <img src={syllbusicon} alt="online neet" />
                                    <p>Syllabus As per NTA </p>
                                </div>
                                <div className={`${styles.detail1}`}>
                                    <img src="https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/online-icon1.svg" alt="online neet" />
                                    <p>As per new NEET pattern. </p>
                                </div>
                            </div>
                        </div>
                        <div className={`${styles.test_pre_box}`}>
                            <div className={`${styles.impr_img}`}><img src={importantIcon} alt="icon" /></div>
                            <div className={`${styles.heading_test}`}>
                                <h2>Things to remember</h2>
                            </div>
                            <div className={`${styles.detail_pre}`}>
                                <div className={`${styles.detail1}`}>
                                    <h2>Arrival time</h2>
                                    <h6>30 minutes before the exam begins </h6>
                                </div>
                                <div className={`${styles.detail1}`}>
                                    <h2>Admit Card</h2>
                                    <h6>Printed Admit Card required for entry.</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* -------MOCK NEET test prepration */}
                </div>
            </div>
        </div>
    )
}

export default NeetTestCriteria